
import {css} from "lit"
export default css`

:host {
	color: var(--angry);
}

`
